export function useIntersectionObserver(
  node: Ref<Element | null>,
  options?: IntersectionObserverInit,
  once?: boolean,
) {
  const isIntersecting = ref(false)
  const observer = ref<IntersectionObserver>()

  const createObserver = () => {
    observer.value = new IntersectionObserver(onIntersect, {
      root: null,
      rootMargin: '0px',
      ...options,
    })

    if (node.value) {
      observer.value.observe(node.value)
    }
  }

  const onIntersect: IntersectionObserverCallback = (entries, _observer) => {
    isIntersecting.value = entries[0].isIntersecting

    if (entries[0].isIntersecting && once) {
      destroyObserver()
    }
  }

  const destroyObserver = () => {
    // abort if observer is not undefined
    if (!node.value || !observer.value) return

    observer.value.unobserve(node.value)
    observer.value.disconnect()
  }

  onMounted(() => {
    createObserver()
  })
  onUnmounted(() => {
    destroyObserver()
  })

  // expose managed state as return value
  return { isIntersecting, observer }
}
